var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-right" },
    [
      _c(
        "b-button",
        {
          staticClass: "btn-icon rounded-circle mt-1",
          attrs: { size: "sm", id: "popover-stamp", variant: "flat-primary" }
        },
        [_c("feather-icon", { attrs: { icon: "InfoIcon" } })],
        1
      ),
      _c(
        "b-popover",
        {
          attrs: {
            target: "popover-stamp",
            triggers: "focus",
            placement: "top"
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function() {
                return [_c("span", [_vm._v("Estampar aprobaciones!")])]
              },
              proxy: true
            }
          ])
        },
        [
          _c("span", [
            _vm._v(
              " Esto significa que luego de cada aprobación quede una marca de visto bueno ✅ en el documento. "
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }